import { memo } from "react";
import NestedRouting from "./NestedRouting";
import Routing from "./Routing";
import { useRoutes } from "react-router-dom";

const RouteProvider = memo(() => {
  return useRoutes([NestedRouting, ...Routing]);
});

RouteProvider.displayName = "RouteProvider";
export default RouteProvider;